import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  TemplateRef,
} from '@angular/core';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { ButtonComponent } from '../../feedback/button/button.component';

@Component({
  selector: 'aw-simple-overlay',
  imports: [NgTemplateOutlet, OverlayModule, ButtonComponent],
  templateUrl: './simple-overlay.component.html',
})
export class SimpleOverlayComponent {
  public readonly messageContent: InputSignal<TemplateRef<unknown>> = input.required<TemplateRef<unknown>>();
  public readonly closed: OutputEmitterRef<void> = output<void>();
  public readonly accepted: OutputEmitterRef<void> = output<void>();

  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  protected readonly overlayPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      offsetY: 16,
    }
  ];
}
